/**
 * Client for the backend's lifecycle email endpoint (/emails/welcome).
 */
import { User } from 'firebase/auth';
import { BACKEND_URL } from './developerApi';
import { UserProfile } from './types';

/**
 * Ask the backend to send the sign-up welcome email. The backend sends it
 * at most once per user and records the outcome on the profile
 * (`welcomeEmail`), so this only fires until that field is set. Requires a
 * verified email; never throws.
 */
export async function requestWelcomeEmailIfNeeded(user: User, profile: UserProfile | null): Promise<void> {
  if (!user.emailVerified || !profile || profile.welcomeEmail) return;
  try {
    const token = await user.getIdToken();
    await fetch(`${BACKEND_URL}/emails/welcome`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ locale: profile.locale || navigator.language }),
    });
  } catch (err) {
    console.warn('Welcome email request failed:', err);
  }
}
